import orderBy from 'lodash/orderBy';
import { checkTokenExpiration } from '../utils/checkTokenExpiration';
import { getCurrentSession } from '../../lib/authentication';

export const fetchAll = async (includeDisabled = false) => {
  const { accessToken } = await getCurrentSession()
  const params = includeDisabled ? { includeDisabled } : {};
  const response = await apigClient.brokeragesGet(
    params,
    {},
    {
      headers: { Authorization: accessToken }
    }
  );

  return orderBy(response.data.data.Items, ['name'], ['asc']);
};

export const updateBrokerage = (id, broker, user) => {
    return Promise.all([checkTokenExpiration(user), getCurrentSession()]).then(results => {
        const [expirationToken, currentSession] = results;
        const { accessToken } = currentSession;

        return apigClient.brokeragesPut({ id: id }, broker, {
            headers: { Authorization: accessToken }
        });
    });
};

export const salesforceSynchronization = async (agencyCode = null) => {
  const { accessToken } = await getCurrentSession();
  const params = agencyCode ? { agencyCode } : {};
  const response = await apigClient.salesforceSynchronization(
    params,
    {},
    {
      headers: { Authorization: accessToken }
    }
  );
  if (response?.status !== 200) {
    throw new Error('Salesforce synchronization error');
  } else if (Array.isArray(response?.data?.successfulUpdates)) {
    return response.data.successfulUpdates;
  } else {
    return [];
  }
};
